import { render, staticRenderFns } from "./ExFoldSign.vue?vue&type=template&id=3ca3a665&scoped=true"
import script from "./ExFoldSign.vue?vue&type=script&lang=js"
export * from "./ExFoldSign.vue?vue&type=script&lang=js"
import style0 from "./ExFoldSign.vue?vue&type=style&index=0&id=3ca3a665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3a665",
  null
  
)

export default component.exports